import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import ModuleHead from '../components/moduleHead';

const formatTime = newsTime => {
    if (!newsTime || typeof newsTime !== 'string') return '';

    return newsTime.length >= 16 ? newsTime.substring(5, 16) : newsTime;
};

const toDateTimeAttr = newsTime => {
    if (!newsTime || typeof newsTime !== 'string') return undefined;
    const m = newsTime.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})(?::(\d{2}))?/);

    if (!m) return undefined;

    return `${m[1]}T${m[2]}:${m[3] || '00'}+08:00`;
};

/**
 * 有图：左图右文；无图：紧凑文字卡片（避免单条时空洞）
 */
class News extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    renderMeta = item => {
        const time = formatTime(item.newsTime);
        const dateTime = toDateTimeAttr(item.newsTime);
        const hasSource = Boolean(item.source);

        if (!time && !hasSource) return null;

        return (
            <div className={styles.meta}>
                {time ? (
                    <time className={styles.metaItem} dateTime={dateTime}>
                        {time}
                    </time>
                ) : null}
                {time && hasSource ? <span className={styles.dot}>·</span> : null}
                {hasSource ? <span className={styles.metaItem}>{item.source}</span> : null}
            </div>
        );
    };

    renderItem = (item, index) => {
        const hasImage = Boolean(item.thumbnail);
        const className = hasImage ? styles.newsFeed : styles.newsText;

        return (
            <article key={item.id || index} className={className}>
                <a href={item.url} target="_blank" rel="noopener noreferrer" className={styles.newsLink}>
                    {hasImage ? (
                        <div className={styles.newsFeedImgBox}>
                            <img className={styles.newsFeedImg} src={item.thumbnail} alt={item.title || ''} />
                        </div>
                    ) : null}
                    <div className={styles.newsFeedText}>
                        <h3 className={hasImage ? styles.newsFeedTitle : styles.newsTextTitle}>{item.title}</h3>
                        {!hasImage && item.summary ? <p className={styles.summary}>{item.summary}</p> : null}
                        {this.renderMeta(item)}
                    </div>
                </a>
            </article>
        );
    };

    render() {
        const { content } = this.props;
        const head = content.head || {};
        const list = Array.isArray(content.list) ? content.list : [];
        const sectionId = content.sectionId || '';

        if (!list.length) return null;

        return (
            <section className={styles.news} aria-labelledby={sectionId ? `mod-${sectionId}` : undefined}>
                <ModuleHead content={head} headingId={sectionId ? `mod-${sectionId}` : undefined} />
                <div className={styles.newsContent}>{list.map(this.renderItem)}</div>
            </section>
        );
    }
}

export default errorBoundary(News);
